import { render, staticRenderFns } from "./CreateEmployeeForm.vue?vue&type=template&id=56ff209e&scoped=true"
import script from "./CreateEmployeeForm.vue?vue&type=script&lang=js"
export * from "./CreateEmployeeForm.vue?vue&type=script&lang=js"
import style0 from "./CreateEmployeeForm.vue?vue&type=style&index=0&id=56ff209e&prod&lang=scss&scoped=true"
import style1 from "./CreateEmployeeForm.vue?vue&type=style&index=1&id=56ff209e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff209e",
  null
  
)

export default component.exports